import { LOAD_DATAQUEST_DATA } from '../constants'

const dataquest = (state={}, action) => {
  switch(action.type) {
    case LOAD_DATAQUEST_DATA:
      return {...action.data}
    default:
      return state;
  }
}

export default dataquest


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/reducers/dataquestReducer.js